import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Paper as MuiPaper, Grid, Typography, Link } from "@mui/material";

import useAxios from "../../hooks/useAxios";

const Paper = styled(MuiPaper)`
  margin: 2px 10px;
  padding: 15px 10px;
`;

const GridContainer = styled(Grid)`
  height: 100%;
  align-items: center;
`;

export default function PoweredBy() {
  const axios = useAxios();
  const [name, setName] = useState("DigiPass");

  useEffect(() => {
    if (sessionStorage.getItem("authToken")) {
      axios({
        url: "/admin/business/get-business-theme",
        customAuthToken: sessionStorage.getItem("authToken"),
        disableError: true,
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setName(response.data.name);
        }
      });
    }
  }, []);

  return (
    <Paper>
      <GridContainer container>
        <Grid item xs>
          <Link href="#" sx={{ color: "rgb(57, 54, 239)", fontWeight: 900 }}>
            Powered By Aionos
          </Link>
        </Grid>

        <Grid item xs>
          <Typography variant="subtitle2" align="right">
            © Aionos {new Date().getFullYear()}
          </Typography>
        </Grid>
      </GridContainer>
    </Paper>
  );
}
